//modules
import React, { useEffect, useRef } from 'react';

//components
import { NavigationBar } from '../globalComponents/NavigationBar';
import { StuffCard } from '../globalComponents/StuffCard';
import { useTextAnimation } from '../globalComponents/UseTextAnimation';
import { RightsFooter } from '../globalComponents/RightsFooter';

//styles
import './OtherStuff.css';
import perrasrosadas from '../images/perrasrosadas.webp';
import lapatria from '../images/lapatria.webp';
import doldrumdrifters from '../images/doldrumdrifters.webp';
import p5js from '../images/p5js.webp';


export const OtherStuff = ({ className }) => {

    const StuffData = [ 
        ['Perras Rosadas', 'NFT illustration collection on Solana marketplace Exchange.Art, 2021.', perrasrosadas, 'https://exchange.art/series/Perras%20rosadas/nfts'],
        ['La Patria', 'Physical and digital archive of Uruguayan graphic design that I help maintaining.', lapatria, 'https://lapatria.uy/'],
        ['P5.js Experiments', 'Experiments I made with the processing javascript library of P5.js', p5js, 'https://editor.p5js.org/varrogan/sketches'],
        ['Doldrum Drifters', 'NFT illustration collection on Ethereum marketplace Foundation, 2022.', doldrumdrifters, 'https://foundation.app/collection/doldrum-drifters'],
     ];

     const { headingRef, bodyRef } = useTextAnimation();
     const carouselRef = useRef(null);

useEffect(() => {
    const carousel = carouselRef.current;
    if (!carousel) return;

    const handleWheel = (e) => {
        const isVertical = Math.abs(e.deltaY) > Math.abs(e.deltaX);
        if (!isVertical) return;

        e.preventDefault();

        const sensitivity = 2.5;

const delta =
    Math.sign(e.deltaY) *
    Math.max(Math.abs(e.deltaY) * sensitivity, 8);

carousel.scrollLeft += delta;
    };

    carousel.addEventListener("wheel", handleWheel, { passive: false });

    return () => {
        carousel.removeEventListener("wheel", handleWheel);
    };
}, []);

    return(
        <div className="subpage-main-container no-scroll">  
            <NavigationBar />
            <div className="subpage-content">
                <div className="subpage-heading">
                    <h2 className="heading-2" ref={headingRef}>Other Stuff.</h2>
                    <div className="subpage-subtitle">
                        <p className="subtitle italic" ref={(el) => (bodyRef.current[0] = el)}>Stuff I built because</p>
                        <p className="subtitle italic" ref={(el) => (bodyRef.current[1] = el)}>I can’t sit still.</p>
                    </div>
                </div>

                <div className="stuff-carousel" ref={carouselRef}>
                     {StuffData.map((data, index) => (
                         <StuffCard
                           title={data[0]}
                           description={data[1]}
                           image={data[2]}
                           path={data[3]}
                           customClass="default-class"
                           isExternal={true}
                         />
                     ))}
                </div>
            </div>
            <RightsFooter customClass= "footer-default-class" />
        </div>
    )
};